<template>
  <div id="delivery-observation">
    <v-dialog v-model="isOpen" persistent max-width="500">
      <v-card class="align-center">
        <v-card-title>
          <div class="d-flex align-center justify-space-between w-100">
            <h1>Editar Observação da Cte</h1>
            <v-btn icon @click="close" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="mt-4 text-center">
          <v-row class="mt-5 d-flex justify-center mx-auto">
            <v-col cols="12">
              <v-textarea v-model="delivery.observation" label="Observação"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex pb-4 px-5">
          <v-btn class="flex-grow-1" color="error" large @click="close"> Cancelar </v-btn>
          <v-btn
            class="flex-grow-1"
            color="success"
            large
            :disabled="!delivery.observation"
            :loading="isConfirmButtonLoading"
            @click="editObservation()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import MessagesError from '@/components/MessagesError.vue';

export default {
  props: {
    isOpen: {
      default: false,
      type: Boolean
    },
    deliveryToEditObservation: {
      default: () => ({
        id: null,
        observation: null
      }),
      type: Object
    }
  },
  components: {
    MessagesError
  },
  data: () => ({
    isConfirmButtonLoading: false,
    delivery: {
      id: null,
      observation: null
    },
    errors: [],
    errorsType: 'error',
    error500: null
  }),

  watch: {
    isOpen: {
      async handler(isOpen) {
        if (isOpen) {
          const { id, observation } = this.deliveryToEditObservation;

          this.delivery = {
            id,
            observation
          };
        }
      }
    }
  },

  methods: {
    ...mapActions('ShippersReceivableStore', ['updateObservationDelivery']),

    async editObservation() {
      try {
        this.isConfirmButtonLoading = true;

        const data = await this.updateObservationDelivery(this.delivery);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (e) {
        console.error(e);
        this.errors = ['Opss, algo deu errado!'];
        this.errorsType = 'error';
      } finally {
        this.isConfirmButtonLoading = false;
        this.setClearErrorTimer();
        this.close();
      }
    },

    handleSuccessFeedback() {
      this.errors = ['Fatura rejeitada com sucesso!'];
      this.errorsType = 'success';
      this.setClearErrorTimer();
      this.$emit('shouldUpdateList');
    },

    setClearErrorTimer() {
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    },

    close() {
      this.$emit('update:isOpen', false);
    }
  }
};
</script>
